export default "__VITE_ASSET__BR5SC4Ln__"